import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';
import { useAnimation } from '../../hooks/useAnimation';
import fabricService from '../../services/fabricService';
import config from '../../config';
import './AllFabricsPage.scss';

const AllFabricsPage = () => {
  const { t } = useTranslation();
  const { fadeOnly, staggerContainer, slideInUp } = useAnimation();
  const [fabrics, setFabrics] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    loadFabrics();
  }, []);

  const loadFabrics = async () => {
    try {
      setLoading(true);
      const data = await fabricService.getAllFabrics();
      setFabrics(data);
    } catch (error) {
      console.error('Failed to load fabrics:', error);
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="all-fabrics-page">
        <Container>
          <div className="text-center py-5">
            <div className="spinner-border" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
        </Container>
      </div>
    );
  }

  if (error) {
    return (
      <div className="all-fabrics-page">
        <Container>
          <div className="text-center py-5">
            <p>Kumaşlar yüklenirken hata oluştu: {error}</p>
          </div>
        </Container>
      </div>
    );
  }

  return (
    <div className="all-fabrics-page">
      <Container>
        <motion.div
          className="page-header text-center mb-5"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: false, amount: 0.3 }}
          variants={fadeOnly}
        >
          <h1>{t('features.title')}</h1>
          <p className="lead">{t('features.description')}</p>
        </motion.div>

        <motion.div
          variants={staggerContainer}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: false, amount: 0.2 }}
        >
          <Row xs={1} md={2} lg={3} className="g-4">
            {fabrics.map((fabric, index) => (
              <Col key={fabric.id}>
                <motion.div variants={slideInUp}>
                  <Card className="fabric-card h-100">
                    <div className="fabric-image-container">
                      <Card.Img
                        variant="top"
                        src={fabric.main_image ? (() => {
                          if (fabric.main_image.startsWith('/api/')) {
                            return `https://tekstas.com${fabric.main_image}`;
                          } else if (fabric.main_image.startsWith('/uploads/')) {
                            return `${config.API_URL}${fabric.main_image}`;
                          } else if (fabric.main_image.includes('assets/images/')) {
                            return require(`../../assets/images/${fabric.main_image.split('/').pop()}`);
                          } else {
                            return `${config.API_URL}${fabric.main_image}`;
                          }
                        })() : require('../../assets/images/fabric-type-cotton.png')}
                        alt={fabric.name}
                        onError={(e) => {
                          e.target.src = require('../../assets/images/fabric-type-cotton.png');
                        }}
                      />
                    </div>
                    <Card.Body>
                      <Card.Title>{fabric.name}</Card.Title>
                      <Card.Text>{fabric.description}</Card.Text>
                    </Card.Body>
                  </Card>
                </motion.div>
              </Col>
            ))}
          </Row>
        </motion.div>
      </Container>
    </div>
  );
};

export default AllFabricsPage; 